import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Loader = () => {
    return (
        <DotLottieReact
            src="https://lottie.host/3c09a4d0-5cb8-4f9f-af2e-48ae22f97fea/dZ5y7kJ0ZD.lottie"
            loop
            autoplay
        />
    )
}

export default Loader


